<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

<!--      <ComingSoon/>-->

      <!--  =========== Start:: Data Table =========== -->
       <div class="statics mt-4">
        <div class="row">
          <div
            :class="getAuthenticatedUserData?.type === 'admin' ? 'col-lg-6 col-md-6 col-12' : 'col-lg-12 col-md-12 col-12'"
            v-for="(value, key) in statics"
            :key="'i' + key"
          >
            <div class="box">
              <div class="icon">
                <i v-if="key === 'clients'" class="fas fa-users"></i>
                <i v-if="key === 'providers'" class="fas fa-users"></i>
                <i v-if="key === 'festival_providers'" class="fas fa-building"></i>
                <i v-if="key === 'admins'" class="fas fa-users"></i>
                <i v-if="key === 'festival_orders'" class="fas fa-gift-card"></i>
                <i v-if="key === 'product_orders'" class="fas fa-shopping-bag"></i>
                <i v-if="key === 'provider_favorites'" class="fas fa-bookmark"></i>
                <i v-if="key === 'festival_favorites'" class="fas fa-bookmark"></i>
              </div>

              <div class="info_box">
                <span v-if="key === 'clients'">{{$t("MESSAGES.Total number of clients") }}</span>
                <span v-if="key === 'providers'">{{$t("MESSAGES.Total number of service providers") }}</span>
                <span v-if="key === 'festival_providers'">{{$t("MESSAGES.Total number of centers") }}</span>
                <span v-if="key === 'admins'">{{$t("MESSAGES.Total number of system administrators") }}</span>
                <span v-if="key === 'festival_orders'">{{$t("MESSAGES.Total number of event requests") }}</span>
                <span v-if="key === 'product_orders'">{{$t("MESSAGES.Total number of product orders") }}</span>
                <span v-if="key === 'provider_favorites'">{{$t("MESSAGES.Total number of service provider favorites") }}</span>
                <span v-if="key === 'festival_favorites'">{{$t("MESSAGES.Total number of event favorites") }}</span>

                <p class="number_box">{{ value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";
import {mapGetters} from "vuex";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },
  computed: {
    ...mapGetters({
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
  },
  data() {
    return {
      statics: [],
    };
  },

  methods: {
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "statistic",
        });

        let data = res.data.data.data;
        if (this.getAuthenticatedUserData?.type === 'admin'){
          this.statics = data;
        }else {
          this.statics = {
            festival_orders: data.festival_orders
          };
        }
        console.log(this.statics)
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .statics {
    .box {
      background: #405950;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #405950;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
.show_all_content_wrapper .statics .box .info_box{
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
</style>
